import { render, staticRenderFns } from "./GridSection.vue?vue&type=template&id=6b092be0"
import script from "./GridSection.vue?vue&type=script&lang=ts"
export * from "./GridSection.vue?vue&type=script&lang=ts"
import style0 from "./GridSection.vue?vue&type=style&index=0&id=6b092be0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports